import React, { useCallback } from 'react';
import { Box } from '@mui/material';
import useInterveneSx from '../hooks/useInterveneSx';

export default function FilterTabs({ value, onChange, tabs, chatCounts }) {
  const styles = useInterveneSx();

  const handleKeyDown = useCallback(
    (event, tabValue, index) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        onChange?.(tabValue);
        return;
      }

      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        const nextIndex = (index + direction + tabs.length) % tabs.length;
        onChange?.(tabs[nextIndex].value);
      }
    },
    [onChange, tabs]
  );

  return (
    <Box sx={styles.filterTabBar} role="tablist" aria-label="Conversation filters">
      {tabs.map((tab, index) => {
        const isActive = value === tab.value;
        const count = chatCounts?.[tab.countKey] ?? 0;

        return (
          <Box
            key={tab.value}
            component="button"
            type="button"
            role="tab"
            aria-selected={isActive}
            tabIndex={isActive ? 0 : -1}
            aria-label={`${tab.label} (${count})`}
            title={`${tab.label} (${count})`}
            onClick={() => onChange?.(tab.value)}
            onKeyDown={(event) => handleKeyDown(event, tab.value, index)}
            sx={[styles.filterTab, isActive && styles.filterTabActive]}
          >
            <Box component="span" sx={styles.filterTabLabel}>
              {tab.label}
            </Box>
            <Box
              component="span"
              sx={[styles.filterTabBadge, isActive && styles.filterTabBadgeActive]}
            >
              {count}
            </Box>
          </Box>
        );
      })}
    </Box>
  );
}
